// Authentication token key used in cookies - it matches the old app's token name (rh-web/config/constants.js)
export const AUTH_TOKEN = 'researchhub.auth.token';
